import React from 'react';

import { Link } from 'react-router';

import moment from 'moment';
import qs from 'qs';

import { formatMoney } from '../../../../shared/js/format';

import renderComment from './render-comment-td';
import renderReason from './render-reason';

const isRocket = process.env.CPA_ENV === 'rocket';

const descriptions = {
	'returned': 'Пришло более 1 лида после более 15 дней без лидов',
	'started': 'Пришло более 1 лида после регистрации',
	'volumes-decreased': 'Кол-во лидов за вчера уменьшилось на 20%, чем в среднем за предыдущие 3 дня',
	'stopped': 'За вчера не было ни одного валидного лида',
	'insufficient-profit': 'За период от -19 до -12 дней маржа меньше 14$',
	'inbound': 'В 1C произошло событие "Проведен приход"',
	'cap-exceeded': 'Кол-во всего лидов за вчера больше чем на 5% от кол-ва в CAP',
	'product-cap': 'Товарная капа меньше чем кол-во всего лидов по продукту за вчера'
};

function renderTitle({ value }, { row }) {
	const description = isRocket ? descriptions[row.event] : undefined;
	const filters = [];

	if (row.affiliate) {
		filters.push({ name: 'affiliates', values: [row.affiliate] });
	}
	if (row.country) {
		filters.push({ name: 'countries', values: [row.country] });
	}
	if (row.offers) {
		filters.push({ name: 'offers', values: row.offers });
	}

	if (filters.length) {
		const query = qs.stringify({
			query: {
				filters: filters.reduce((acc, filter) => ({
					...acc,
					[filter.name]: filter.values.map((o) => o.value)
				}), {})
			},
			entity: {
				filters
			}
		});

		return (
			<Link
				className='alerts-analytics-link'
				to={`/statistics/general?${query}`}
				target='_blank'
				title={description}
			>
				{value}
			</Link>
		);
	}

	return (
		<span title={description}>{value}</span>
	);
}

function renderLeads({ child }, { row }) {
	return ['stopped', 'volumes-decreased', 'bump-failed'].includes(row.event) ? child : '';
}

function renderOptions({ value }) {
	return !value ? '-' : (
		<div>
			{value.map((o, i) => (
				<div key={i}>{o.label} ({o.value})</div>
			))}
		</div>
	);
}

function renderOption({ value }) {
	return !value ? '-' : (
		<div>
			{value.label} ({value.value})
		</div>
	);
}

const columnSorting = {
	key: 'column',
	remote: true,
	direction: 'desc'
};

const table = [
	[
		{
			index: 'date',
			header: {
				title: 'Date',
				sorting: columnSorting
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'title',
			header: {
				title: 'Alert',
				sorting: columnSorting
			},
			column: {
				render: renderTitle
			}
		},
		{
			index: 'manager',
			header: {
				title: 'Manager',
				sorting: columnSorting
			},
			column: {
				render: renderOption
			}
		},
		{
			index: 'affiliate',
			header: {
				title: 'Affiliate',
				sorting: columnSorting
			},
			column: {
				render: renderOption
			}
		},
		{
			index: 'offers',
			header: {
				title: 'Offers',
				sorting: columnSorting
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'country',
			header: {
				title: 'Geo',
				sorting: columnSorting
			},
			column: {
				render: renderOption
			}
		},
		{
			index: 'leads',
			header: {
				title: 'Leads',
				sorting: {
					key: 'column',
					remote: false,
					direction: 'desc'
				}
			},
			column: {
				format: formatMoney,
				render: renderLeads
			}
		},
		{
			index: 'reason',
			header: {
				title: 'Reason',
				sorting: columnSorting
			},
			column: {
				render: renderReason
			}
		},
		{
			index: 'comment',
			header: {
				title: 'Comment'
			},
			column: {
				render: renderComment
			}
		}
	]
];

const sortedBy = {
	column: {
		index: 'date',
		direction: 'desc'
	}
};

export default {
	table,
	sortedBy
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/alerts-analytics/table-initial-data.js